module.exports = __webpack_public_path__ + "html/section-video-statistics_404858ab8fd51e259c3b56f932d44f4c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-statistics.html
// module id = Z0Ui
// module chunks = 53